export const defaultCharacter = {
  name: '',
  age: 0,
  gender: 5,
  heightM: 0,
  heightFt: 0,
  heightIn: 0,
  weightKg: 0,
  weightLbs: 0,
  species: '',
  isImperial: true,
  currentResilience: 0,
  totalResilience: 0,
  currentHealth: 0,
  totalHealth: 0,
  deathThreshold: 0,
  isDead: false,
  availablePoints: 20,
  usedPoints: 0,
  luckPoints: [],
  traits: {},
  previousSave: false,
  unsavedChanges: false,
  selectedHealTrait: {},
  selectedRepairTrait: {},
  usedTraits: [],
  storage: [],
  primaryWeaponId: '',
  secondaryWeaponId: '',
  equipmentId: '',
};

export const defaultGear = {
  id: '',
  name: '',
  trait: '',
  isSpecial: false,
  isOversized: false,
  isEquipment: false,
  isHealthItem: false,
  isRepairItem: false,
  totalUses: null,
  remainingUses: null,
  description: '',
  additionalDamage: [],
  bonus: 0,
};
